import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-success-checkout',
  templateUrl: './success-checkout.component.html',
  styleUrls: ['./success-checkout.component.scss'],
})
export class SuccessCheckoutComponent implements OnInit {

  constructor(
    private modalCtrlr: ModalController,) { }

  ngOnInit() {}

  close(){
    this.modalCtrlr.dismiss();
  }

}
